import './ScreenshotPreview.scss'
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { observer } from 'mobx-react';
import { ScreenshotPreviewVM } from './ScreenshotPreviewVM';
import { Loader } from '../LoadingSpinner/LoadingSpinner';
import { ComboBox } from 'cd-eft/components/common/ComboBox'; 

interface ScreenshotPreviewProps {
    vm: ScreenshotPreviewVM;
}

export const ScreenshotPreview = observer(function ScreenshotPreview(props: ScreenshotPreviewProps) {
    const vm = props.vm;
    return (
        <Modal className="screenshot-preview-modal" isOpen={vm.isOpen}>
            {vm.isLoading && <Loader message={'Saving...'} />}
            <ModalHeader>
                <strong>{vm.title}</strong>
            </ModalHeader>
            <ModalBody>
                <div>
                    <ComboBox
                        idAndName="image-type"
                        label="Type:"
                        aria-label="Type:"
                        value={vm.selectedImageType}
                        onChange={vm.handleImageTypeChange}
                        options={vm.imageTypeOptions}
                        required={true}
                        valid={true}
                        errorMsg={""}
                        className={""}
                    />
                </div>
                <div className="screenshot-image-container">
                    <img className="screenshot-preview-image" src={vm.imageData} alt="Sccreenshot Image" />
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="usa-button usa-button--outline" onClick={vm.cancel}>
                    Close
                </button>
                <button className="usa-button" onClick={vm.accept} disabled={vm.saveDisabled}>
                    Save
                </button>
            </ModalFooter>
        </Modal>
    );
});
